const {jQuery: $} = window;

import Utils from "./utils.class";

export default class ActiveCampaign {
    #host;
    #bannedDomains;
    #freeDomains;
    #autosetValues;
    #tooltips = [];

    /**
     *
     * @param host
     * @param bannedDomains
     * @param freeDomains
     * @param autosetValues
     */
    constructor(host, bannedDomains = [], freeDomains = [], autosetValues = []) {
        this.#host = host;
        this.#bannedDomains = bannedDomains;
        this.#freeDomains = freeDomains;
        this.#autosetValues = autosetValues;

        Utils.log(freeDomains);
    }

    load() {
        Utils.log("[ActiveCampaign] Load active campaign integration");

        $(".js-mkto-hide").addClass("js-hidden");

        window._form_callback = (id) => {
            Utils.log("Submit Form:", id);
            $(window).trigger(`kmdg_activecampaign_form_${id}_submit`);
        }

        $(window).trigger("kmdg_activecampaign_ready", [this]);
    }

    createTooltip (elem, text) {
        const tooltip = document.createElement('div')
            , arrow = document.createElement('div')
            , inner = document.createElement('div')
            , new_tooltip = {};
        if (elem.type !== 'radio' && (elem.type !== 'checkbox' || elem.name === 'sms_consent')) {
            tooltip.className = '_error';
            arrow.className = '_error-arrow';
            inner.className = '_error-inner';
            inner.innerHTML = text;
            tooltip.appendChild(arrow);
            tooltip.appendChild(inner);
            elem.parentNode.appendChild(tooltip);
        } else {
            tooltip.className = '_error-inner _no_arrow';
            tooltip.innerHTML = text;
            elem.parentNode.insertBefore(tooltip, elem);
            new_tooltip.no_arrow = true;
        }
        new_tooltip.tip = tooltip;
        new_tooltip.elem = elem;
        this.#tooltips.push(new_tooltip);
        return new_tooltip;
    }

    resizeTooltip(tooltip) {
        const rect = tooltip.elem.getBoundingClientRect();
        let doc = document.documentElement
            , scrollPosition = rect.top - ((window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0));
        if (scrollPosition < 40) {
            tooltip.tip.className = tooltip.tip.className.replace(/ ?(_above|_below) ?/g, '') + ' _below';
        } else {
            tooltip.tip.className = tooltip.tip.className.replace(/ ?(_above|_below) ?/g, '') + ' _above';
        }
    }

    removeTooltip (elem) {
        for (let i = 0; i < this.#tooltips.length; i++) {
            if (this.#tooltips[i].elem === elem) {
                this.#tooltips[i].tip.parentNode.removeChild(this.#tooltips[i].tip);
                this.#tooltips.splice(i, 1);
                return;
            }
        }
    };

    get host() {
        return this.#host
    }

    get bannedDomains() {
        return this.#bannedDomains;
    }

    get freeDomains() {
        return this.#freeDomains;
    }

    get autosetValues() {
        return this.#autosetValues;
    }
}